// import 'babel-polyfill';
import 'helpers/polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { applyMiddleware, createStore, compose } from 'redux';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import sniffer from 'sniffer';
import promise from 'redux-promise';
import reducers from './reducers';

// Top level components
import Localization from 'components/Localization';
import Routes from './routes/index';
import InjectAxiosInterceptors from './lib/injectAxiosInterceptors';
import { LicenseInfo } from '@mui/x-license';
LicenseInfo.setLicenseKey('63e6abc6aa5977ef8ae03fd0c3607cf0Tz0xMjAwNDQsRT0xNzkxNDE3NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Login from './components/Login/Login';
import msalInstance from './lib/msal';
var theme = createTheme({
  typography: {
    fontFamily: "'Open Sans', Arial, sans-serif"
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: "'Open Sans', Arial, sans-serif",
          backgroundColor: '#f5f5f5'
        }
      }
    }
  }
});
sniffer.addClasses(document.documentElement);
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
var store = createStore(reducers, composeEnhancers(applyMiddleware(promise)));
(function () {
  if (window.ReactNativeWebView != null) {
    document.addEventListener("click", function (event) {
      var targetElement = event.target || event.srcElement;
      if (targetElement instanceof HTMLAnchorElement) {
        if (targetElement.target == "_blank") {
          event.preventDefault();
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 'OPEN_URL',
            external_url_open: targetElement.href
          }));
        }
      }
    });
  }
})();
if (window.ReactNativeWebView != null) {
  var originalWindowOpen = window.open;
  window.open = function (url, target, features) {
    if (url && typeof url === 'string') {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'OPEN_URL',
        external_url_open: url
      }));
      return null;
    } else {
      return originalWindowOpen.apply(window, arguments);
    }
  };
}
if (window == window.parent) {
  ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(CssBaseline, null), /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(Localization, null, /*#__PURE__*/React.createElement(Router, null, /*#__PURE__*/React.createElement(MsalProvider, {
    instance: msalInstance
  }, /*#__PURE__*/React.createElement(InjectAxiosInterceptors, null), /*#__PURE__*/React.createElement(AuthenticatedTemplate, null, /*#__PURE__*/React.createElement(Routes, {
    store: store
  })), /*#__PURE__*/React.createElement(UnauthenticatedTemplate, null, /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: Login
  }))))))), document.querySelector('#root'));
}
export default store;